export class ProviderNotFoundError extends Error {
    constructor(methodName: string) {
        super(`Unable to find Auth Provider with method: ${methodName}`);
    }
}
